import { useLocation } from "react-router-dom";

import { Environment, useAppContext } from "@at/sauron-platform-core";

export const useGetCanonicalUrl = () => {
  const { pathname } = useLocation();

  const {
    config: { env },
  } = useAppContext();

  const prod = "https://www.autotrader.co.uk";
  const preprod = "https://www-preprod.autotrader.co.uk";
  const local = "http://localhost.autotrader.co.uk:3000";

  let rootCanonical;

  switch (env) {
    case Environment.prod: {
      rootCanonical = prod;
      break;
    }
    case Environment.preprod: {
      rootCanonical = preprod;
      break;
    }
    case Environment.local: {
      rootCanonical = local;
      break;
    }
    default: {
      rootCanonical = prod;
    }
  }
  return `${rootCanonical}${pathname}`;
};
